import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  PHOTO_MANAGER_SUBSCRIPTION_FEATURES,
  PRO_PHOTO_MANAGER_SUBSCRIPTION_FEATURES,
} from '../../../../apps/pro/views/Account/AccountPhotoManagerSettings/components/PhotoManagerSubscriptionCheckout/helpers';
import Button from '../../../../components/global/Button';
import useBasename from '../../../../components/routing/useBasename';
import { BASENAME } from '../../../../constants/basenames';

const propTypes = {
  className: PropTypes.string,
  supportText: PropTypes.node,
};

const RegisterFeatures = ({ className, supportText }) => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const basename = useBasename();
  const classes = classNames({
    [className]: !!className,
    'view-register-features-wrap': true,
  });

  const suscriptionFeatures =
    basename === BASENAME.PRO
      ? PRO_PHOTO_MANAGER_SUBSCRIPTION_FEATURES
      : PHOTO_MANAGER_SUBSCRIPTION_FEATURES;

  const featuresShown = showAllFeatures
    ? suscriptionFeatures
    : suscriptionFeatures.slice(0, 6);

  return (
    <div className={classes}>
      <ul className="view-register-features">
        {featuresShown.map(feature => {
          return <li key={feature}>{feature}</li>;
        })}
        {!showAllFeatures && (
          <li className="d-flex align-items-center">
            And many more features!{' '}
            <Button
              btnStyle="reset"
              className="ml-1 text-extra-bold text-yellow"
              onClick={() => setShowAllFeatures(true)}
            >
              View All
            </Button>
          </li>
        )}
      </ul>

      {supportText}
    </div>
  );
};

RegisterFeatures.propTypes = propTypes;

export default RegisterFeatures;
